import { GatewayApi } from './base';
import { toBase64, Constructor } from '../common';

class EfsFileImpl {
    constructor(
        readonly name: string,
        readonly type: string,
        readonly path: string,
        readonly size?: string,
        readonly mtime?: string,
    ) {}
}

export interface EfsFile extends EfsFileImpl { }

export class FilesApi extends GatewayApi {
    constructor() {
        super('files');
    }

    async index(
        source_path: string
        ){
        let user = ''
        let roles: string[] = [];

        if (this.user){
        user = this.user.name.join();
        roles = this.user.roles;
        }

        if (typeof source_path === 'string'){
        source_path = source_path.split('/').slice(3).join('/');
        }
        else{
        source_path = ''
        }
        const json = await this.invoke('ls', { user, source_path });
        return JSON.parse(json['Payload'])
    }

    async read(
        source_path: string
        ){
        let user = ''

        if (this.user){
        user = this.user.name.join();
        }

        if (typeof source_path === 'string'){
        source_path = source_path.split('/').slice(3).join('/');
        }
        else{
        source_path = ''
        }

        const json = await this.invoke('cat', { user, source_path });
        return json['Payload']
    }

    async remove(
        source_path: string
        ){
        let user = ''
        let roles: string[] = [];

        if (this.user){
        user = this.user.name.join();
        roles = this.user.roles;
        }

        if (roles.includes('Admin')){
            if (typeof source_path === 'string'){
                source_path = source_path.split('/').slice(3).join('/');
            }
            else{
                source_path = ''
            }
            const json = await this.invoke('rm', { user, source_path });
            return json['Payload']
        }
        else{
            return 403
        }
    }

    async write(
        source_path: string,
        files: File[]) {
        let data = await Promise.all(files.map(
            async file => {
                let { name } = file;
                let author = ''
                let content = (await toBase64(file) as string);
                content = content.slice(content.indexOf('base64') + 6);

                if (this.user){
                author = this.user.name.join();
                }

                if (source_path === 'temp_download/'){
                name = source_path+name
                }
                else{
                name=source_path+'/'+name
                }
                return { name, author, content };
            }
        ));

        const s3Upload = await this.invoke('touch', { data });
        if (s3Upload['StatusCode'] === 200){
            return s3Upload['Payload'].replace(/["]+/g, '');
        }
        else{
            return null
        }
    }

   async s3Copy(
        dst_path:string, src_path: string) {
        const s3Upload = await this.invoke('copy', { dst_path, src_path });
        return s3Upload
    }
}
